var $f694e1ecd0344008$exports = {};
$f694e1ecd0344008$exports = {
    "alert": `Melding`,
    "dismiss": `Negeren`
};


export {$f694e1ecd0344008$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
